import styled from 'styled-components';

export const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 9px 0 0;
`;

export const Line = styled.div`
  margin-top: 4px;
  flex: 1;
  border-bottom: 1px solid ${({ theme }) => theme.auth.form.border};
`;

export const Text = styled.span`
  white-space: nowrap;
  padding: 0 10px;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.auth.form.border};
`;
